import { render, staticRenderFns } from "./apply_dingzhi_zhongchou.vue?vue&type=template&id=2e98d00b&scoped=true"
import script from "./apply_dingzhi_zhongchou.vue?vue&type=script&lang=js"
export * from "./apply_dingzhi_zhongchou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98d00b",
  null
  
)

export default component.exports